import { Trash2, X } from 'lucide-react'

interface DiscardChangesModalProps {
  open: boolean
  onCancel: () => void
  onDiscard: () => void
  onSave?: () => void | Promise<void>
  saving?: boolean
  message?: string
}

export default function DiscardChangesModal({
  open,
  onCancel,
  onDiscard,
  onSave,
  saving = false,
  message,
}: DiscardChangesModalProps) {
  if (!open) return null
  return (
    <div className="overlay" onClick={(e) => { if (e.target === e.currentTarget) onCancel() }}>
      <div className="modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Unsaved Changes</h3>
          <button className="modal-close" onClick={onCancel} aria-label="Close">
            <X size={18} />
          </button>
        </div>
        <p style={{
          fontSize: '0.9375rem',
          color: 'var(--color-text-secondary)',
          marginBottom: '1.25rem',
          lineHeight: 1.7,
        }}>
          {message || 'You have unsaved changes. Save them before leaving, or discard them and continue?'}
        </p>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onCancel} disabled={saving}>
            Keep Editing
          </button>
          <button className="btn btn-danger" onClick={onDiscard} disabled={saving}>
            <Trash2 size={16} />
            Discard
          </button>
          {onSave && (
            <button className="btn btn-primary" onClick={() => onSave()} disabled={saving}>
              {saving ? 'Saving…' : 'Save & Continue'}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
